import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ICase, ICaseState } from './types/MainInfo-interface'

const MainInfoState = (state: RootState): ICaseState => state.contractCase

export const CaseMainInfo = createSelector(
    [MainInfoState],
    (state): ICase => state.case,
)
export const LoadingMainInfo = createSelector(
    [MainInfoState],
    (state): boolean => state.isLoadingCase,
)
export const ErrorMainInfo = createSelector(
    [MainInfoState],
    (state): string[] => state.errorCase,
)

export const LastFetchTimeMainInfo = createSelector(
    [MainInfoState],
    (state): null | number => state.lastFetchTimeCase,
)
export const IdCaseMainInfo = createSelector(
    [MainInfoState],
    (state):  null | string => state.idCase,
)